import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classes from './AuthorLevelPopup.module.css'
import beginnerIcon from '../../../../assests/ContentBank/beginner.png';
import advancedIcon from '../../../../assests/ContentBank/advanced.png';
import professionalIcon from '../../../../assests/ContentBank/professional.png';

const AuthorLevelPopup = ({ material, fromPopup }) => {

    const texts = useSelector(state => state.translate.texts);

    const levelRange = useMemo(() => [[0, 15, 0], [15, 30, 1], [30, 50, 2], [50, Number.MAX_VALUE, 3]], []);
    const levelRangeFilter = material?.ideId ? levelRange.filter(l => material?.ideId >= l[0] && material?.ideId < l[1]) : [];
    // const levelNum = levelRangeFilter.length > 0 ? levelRangeFilter[0][2] : 0;
    const levelNum = 2

    const getLevelIcon = () => {
        switch (levelNum) {
            case 1: return beginnerIcon;
            case 2: return advancedIcon;
            case 3: return professionalIcon;
            default: return beginnerIcon;
        }
    }

    return (
        <>
            {levelNum ?
                fromPopup ?
                    <div className={classes.LevelWrapper}>
                        <img className={classes.LevelIconFromPopup} src={getLevelIcon()} alt="LevelIcon" />
                        <div className={classes.Level}>
                            <div className={classes.LevelTitle}>{texts.authorLevel[levelNum - 1]}</div>
                            <div>{texts.authorLevelContent[levelNum - 1]}</div>
                        </div>
                    </div> :
                    <img className={classes.LevelIcon} src={getLevelIcon()} alt="LevelIcon" /> : ''}
        </>
    )
}
export default AuthorLevelPopup